import { useEffect } from "react";
import { useAppPathname } from "@/components/Seo";
import { useSiteData } from "../context/SiteData";

// Injects GA4 (gtag.js) and the Google Search Console verification meta when
// the owner pastes their IDs in Admin → SEO. Inactive until configured.
export const Analytics = () => {
  const { settings } = useSiteData();
  const pathname = useAppPathname();
  const gaId = settings.ga_measurement_id;
  const gscToken = settings.gsc_verification;

  useEffect(() => {
    if (gscToken && !document.querySelector('meta[name="google-site-verification"]')) {
      const el = document.createElement("meta");
      el.name = "google-site-verification";
      el.content = gscToken;
      document.head.appendChild(el);
    }
  }, [gscToken]);

  useEffect(() => {
    if (!gaId) return;
    if (!document.getElementById("ga-gtag")) {
      const s = document.createElement("script");
      s.id = "ga-gtag";
      s.async = true;
      s.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
      document.head.appendChild(s);
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () {
        window.dataLayer.push(arguments);
      };
      window.gtag("js", new Date());
      window.gtag("config", gaId, { send_page_view: false });
    }
  }, [gaId]);

  // SPA pageview tracking
  useEffect(() => {
    if (gaId && window.gtag) {
      window.gtag("event", "page_view", { page_path: pathname, page_title: document.title });
    }
  }, [gaId, pathname]);

  return null;
};
